export default __webpack_public_path__ + "images/SpeakersPhotos/Paloma Velázquez_Genetsis.jpg?792c0b15";